import { ThemeConfig } from './types'
import { typography, breakpoints, components } from './base.theme'

export const sunsetTheme: ThemeConfig = {
  id: 'sunset',
  name: 'Sunset',
  description: 'Warm sunset colors',
  preview: {
    primaryColor: '#d84315',
    secondaryColor: '#7b1fa2',
  },
  light: {
    palette: {
      mode: 'light',
      primary: {
        main: '#d84315', // Deep orange
        light: '#ff7543',
        dark: '#9f0000',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#7b1fa2', // Purple
        light: '#ae52d4',
        dark: '#4a0072',
        contrastText: '#ffffff',
      },
      background: {
        default: '#fff3e0',
        paper: '#ffffff',
      },
    },
    typography,
    breakpoints,
    components,
  },
  dark: {
    palette: {
      mode: 'dark',
      primary: {
        main: '#ff7043',
        light: '#ffa270',
        dark: '#c63f17',
        contrastText: '#000000',
      },
      secondary: {
        main: '#ab47bc',
        light: '#df78ef',
        dark: '#790e8b',
        contrastText: '#ffffff',
      },
      background: {
        default: '#1a0a0a',
        paper: '#2a1a1a',
      },
    },
    typography,
    breakpoints,
    components,
  },
}
